import _ from 'lodash';

export function getTreeviewDataFormat(payload) {
  let groupdedByAgency = _.groupBy(_.orderBy(payload, 'agency_name'), 'agency_name');
  let agencyExpand = Object.keys(groupdedByAgency);
  let vgpExpanded = [];
  let data = _.map(groupdedByAgency, (data, agencyName) => {
    let videoSensorGroup = _.groupBy(_.orderBy(data, 'video_sensor_group_name'), 'video_sensor_group_name');
    let noVideoSensorGroup = videoSensorGroup[""];
    delete videoSensorGroup[""];
    vgpExpanded = [...vgpExpanded, ...Object.keys(videoSensorGroup)];
    let totalData = [];
    let grp = _.map(videoSensorGroup, (videosensors, vgname) => {
      return {
        id: vgname,
        name: vgname,
        children: _.map(videosensors, (camera) => {
          return {
            id: camera.video_sensor_id,
            name: camera.video_sensor_name,
            ...camera
          };
        })
      };
    });
    let nogrp = _.map(noVideoSensorGroup, (camera) => {
      return {
        id: camera.video_sensor_id,
        name: camera.video_sensor_name,
        ...camera
      };
    });
    totalData = [...grp, ...nogrp];
    return {
      id: agencyName,
      name: agencyName,
      children: totalData
    };
  });
  return { agencyExpand, vgpExpanded, data };
}
